<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.pages.subscription` | trans }}
    </h1>
    <a slot="buttons" :href="routes.dashboard" class="btn btn-primary">
      <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
      Wróć
    </a>
    <v-alert v-if="last_subscription && reached_subscriptions_limit === false" :value="true" type="success">
      <h4>Uwaga</h4>
      <p>
        Twój abonament jest ważny do końca dnia: <strong>{{ expirationDate }}</strong
        >. Jeśli chcesz, możesz przedłużyć ważność swojego abonamentu, wybierając jedną z poniższych opcji. Pamiętaj, że
        możesz przedłużyć swój abonament w dowolnym momencie, a przy przejściu na wyższy plan, dostaniesz zniżkę za
        niewykorzystany okres.
      </p>
    </v-alert>
    <v-alert v-else-if="reached_subscriptions_limit === false" :value="true" type="warning">
      <h4>Uwaga</h4>
      <p>
        Nie posiadasz aktywnej subskrypcji. Wybierz jedną z poniższych opcji abonamentu i przedłuż ważność swojego
        konta.
      </p>
    </v-alert>
    <v-alert v-else :value="true" type="warning">
      <h4>Uwaga</h4>
      <p>
        Opłaciłeś już maksymalną ilość aktywnych subskrypcji i wykupienie kolejnej nie jest aktualnie możliwe.
        <br />Jeśli mimo wszystko chcesz przedłużyć abonament
        <a href="https://dietico.pl/kontakt" target="_blank">kliknij tutaj</a> i skontaktuj się z nami lub zadzwoń pod
        <a href="tel:+48535971889">+48 535 971 889</a>, a przygotujemy dla Ciebie atrakcyjną ofertę!
      </p>
    </v-alert>
    <v-alert :value="showUpgradingAlert" type="warning">
      <h4>Uwaga</h4>
      <p>
        Nie masz możliwości zmiany aktywnego planu STANDARD na miesięczny plan PREMIUM. Wynika to z faktu, że wartość Twojej obecnej subskrypcji jest wyższa niż koszt miesięcznego planu PREMIUM, a niewykorzystany okres nie podlega zwrotowi ani przeliczeniu. Jeśli chcesz korzystać z planu PREMIUM, możesz wybrać subskrypcję na 6 lub 12 miesięcy.
      </p>
    </v-alert>
    <v-app id="vuetify-app" class="no--wrap box box-success">
      <v-container id="subscriptions">
        <v-layout justify-center row wrap class="box-body">
          <a v-if="show_start_discount_banner" :href="routes.start_discount">
            <v-img
              class="elevation-3 mb-20"
              :width="1000"
              :height="300"
              src="/img/pages/start-discount/start_discount_subscription_select.png"
            ></v-img>
          </a>
          <v-flex xs10>
            <div class="container__subscriptions__duration mb-4">
              <v-chip
                @click="setSelectedDuration(30)"
                :color="selectedDuration === 30 ? 'cancel' : 'success'"
                text-color="white"
                :selected="selectedDuration === 30"
                >1 miesiąc</v-chip
              >
              <v-chip
                @click="setSelectedDuration(180)"
                :color="selectedDuration === 180 ? 'cancel' : 'success'"
                text-color="white"
                :selected="selectedDuration === 180"
                >6 miesięcy</v-chip
              >
              <v-chip
                @click="setSelectedDuration(365)"
                :color="selectedDuration === 365 ? 'cancel' : 'success'"
                text-color="white"
                :selected="selectedDuration === 365"
                >12 miesięcy</v-chip
              >
            </div>
          </v-flex>
          <v-flex xs12>
            <v-layout>
              <Subscription
                :availableSubscriptions="getAvailableSubscriptions('free')"
                :subscription="getSubscriptionPlans('free')"
                :free-account-url="routes.free_account"
                :selected-month-duration="selectedDuration === 365 ? 12 : selectedDuration === 180 ? 6 : 1"
                :current_user_subscription="current_subscription"
                :subscriptions="subscriptions"
                :had_paid_subscriptions="had_paid_subscriptions"
              />
              <Subscription
                :availableSubscriptions="getAvailableSubscriptions('student')"
                :subscription="getSubscriptionPlans('student')"
                :free-account-url="routes.free_account"
                :selected-month-duration="selectedDuration === 365 ? 12 : selectedDuration === 180 ? 6 : 1"
                :current_user_subscription="current_subscription"
                :subscriptions="subscriptions"
                :had_paid_subscriptions="had_paid_subscriptions"
              />
              <Subscription
                :availableSubscriptions="getAvailableSubscriptions('standard')"
                :subscription="getSubscriptionPlans('standard')"
                :free-account-url="routes.free_account"
                :selected-month-duration="selectedDuration === 365 ? 12 : selectedDuration === 180 ? 6 : 1"
                :current_user_subscription="current_subscription"
                :subscriptions="subscriptions"
                :had_paid_subscriptions="had_paid_subscriptions"
              />
              <Subscription
                :availableSubscriptions="getAvailableSubscriptions('premium')"
                :subscription="getSubscriptionPlans('premium')"
                :free-account-url="routes.free_account"
                :selected-month-duration="selectedDuration === 365 ? 12 : selectedDuration === 180 ? 6 : 1"
                :current_user_subscription="current_subscription"
                :subscriptions="subscriptions"
                :had_paid_subscriptions="had_paid_subscriptions"
              />
            </v-layout>
          </v-flex>
          <v-alert v-if="!reached_subscriptions_limit" :value="true" type="info">
            <p>
              Chcesz abonament dłuższy niż <strong>ROK</strong>? A może interesuje Cię większa
              <strong>ILOŚĆ KONT</strong>? - <a href="https://dietico.pl/kontakt" target="_blank">kliknij tutaj</a> i
              skontaktuj się z nami lub zadzwoń pod <a href="tel:+48535971889">+48 535 971 889</a>, przygotujemy dla
              Ciebie atrakcyjną ofertę!
            </p>
          </v-alert>
        </v-layout>
      </v-container>
      <v-dialog v-model="invoice_missing" width="800" :persistent="true">
        <order-invoice-form @saved="invoice_missing = false">
          <template v-slot:title>
            <v-toolbar card dark color="primary">
              <v-toolbar-title>{{ 'app.invoice.data' | trans }}</v-toolbar-title>
            </v-toolbar>
          </template>
        </order-invoice-form>
      </v-dialog>
      <v-dialog v-model="showInvoiceDataConfirmDialog" width="800" :persistent="true">
        <order-invoice-form @saved="showInvoiceDataConfirmDialog = false" :save-button-text="`app.confirm` | trans">
          <template v-slot:title>
            <v-toolbar card dark color="primary">
              <v-toolbar-title>{{ 'app.invoice.confirm' | trans }}</v-toolbar-title>
            </v-toolbar>
          </template>
        </order-invoice-form>
      </v-dialog>
    </v-app>
  </base-layout>
</template>
<style lang="scss">
.container__subscriptions__duration .v-chip {
  border-radius: 10px !important;
}
.v-alert {
  padding: 8px !important;

  a:link {
    color: #fff;
    text-decoration: underline;
  }

  a:visited {
    color: #fff;
    text-decoration: underline;
  }
}

.container__subscriptions__duration {
  display: flex;
  justify-content: center;
}
.container__subscriptions__duration .v-chip .v-chip__content {
  cursor: pointer;
}
</style>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import Subscription from './Subscription.vue';
import { getSubscriptionPlans } from './libs';

export default {
  components: { Subscription },
  props: {
    last_subscription: Object,
    current_subscription: Object,
    subscriptions: Object,
    routes: Object,
    reached_subscriptions_limit: Boolean,
    show_start_discount_banner: Boolean,
    subscription_buy_disabled: Boolean,
    tooltip_information: Object,
    invoice_missing: Boolean,
    had_paid_subscriptions: Boolean,
  },
  data: () => ({
    expirationDate: null,
    selectedDuration: 365,
    structure: [],
    showUpgradingAlert: false,
    showInvoiceDataConfirmDialog: true
  }),
  computed: {
    ...mapGetters(['userRole']),
  },
  created() {
    if (this.last_subscription !== null) {
      this.expirationDate = moment(this.last_subscription.end_date).format('DD.MM.Y');
    }
    this.$root.$on('subscription-disabled', ({isUpgrading}) => {
      this.showUpgradingAlert = isUpgrading;
    })
    if (this.invoice_missing) {
      this.showInvoiceDataConfirmDialog = false;
    }
  },
  methods: {
    getSubscriptionPlans,
    getAvailableSubscriptions(name) {
      const subscriptions = Object.values(this.subscriptions);

      switch (name) {
        case 'student':
          return subscriptions
              .filter((subscription) => subscription.role_to_assign === 'dietitian_student')
              .filter((subscription) => subscription.duration === this.selectedDuration)
              .map((subscription) => ({ ...subscription, url: this.getUrl(subscription.role_to_assign, subscription.duration) }));
        case 'standard':
          return subscriptions
            .filter((subscription) => subscription.role_to_assign === 'dietitian_standard')
            .filter((subscription) => subscription.duration === this.selectedDuration)
            .map((subscription) => ({ ...subscription, url: this.getUrl(subscription.role_to_assign, subscription.duration) }));
        case 'premium':
          return subscriptions
            .filter((subscription) => subscription.role_to_assign === 'dietitian_premium')
            .filter((subscription) => subscription.duration === this.selectedDuration)
            .map((subscription) => ({ ...subscription, url: this.getUrl(subscription.role_to_assign, subscription.duration) }));
        case 'free':
          return [];
        default:
          return [];
      }
    },
    setSelectedDuration(duration) {
      this.showUpgradingAlert = false;
      this.selectedDuration = duration;
    },
    getUrl(roleToAssign, duration) {
      if (roleToAssign === 'dietitian_standard') {
        return this.routes.standard_subscription + '?duration=' + duration;
      }
      if (roleToAssign === 'dietitian_student') {
        return this.routes.student_subscription + '?duration=' + duration;
      }
      if (roleToAssign === 'dietitian_premium') {
        return this.routes.premium_subscription + '?duration=' + duration;
      }

      return this.routes.free_account;
    },
  },
};
</script>
